import Three from './Three'
import Wrap from './Wrap';
//import Cube from './Cube';
import Particles from './Particles';
import Loader from './Loader';
import './helper/polyfill-customevent';

const myThree = new Three();
new Loader();

const myWrap = new Wrap({
    three: myThree.three,
    addLoop: myThree.addLoop,
    removeLoop: myThree.removeLoop
});

/*const myCube = new Cube({
    wrap: myWrap.wrap,
    addLoop: myThree.addLoop,
    removeLoop: myThree.removeLoop
})*/

new Particles({
    wrap: myWrap.inner,
    addLoop: myThree.addLoop,
    removeLoop: myThree.removeLoop
})